import ProjectCard from "../components/ProjectCard";
import SplitFlapHero from "../components/SplitFlapHero";
import { projects } from "../content/projects";

/** Renders the public landing page and reviewed project catalog. */
export default function HomePage() {
  return (
    <>
      <section className="hero hero-editorial">
        <div className="hero-copy">
          <p className="eyebrow">Software · Systems · Agentic Engineering</p>
          <SplitFlapHero />
          <p className="hero-summary">
            I design software, automation, simulations, and integration
            workflows that stay understandable, testable, and maintainable after
            the first implementation pass.
          </p>
          <div className="hero-actions">
            <a className="button" href="#projects">
              View projects
            </a>
            <a
              className="button button-secondary"
              href="https://github.com/Gizmo8095"
              target="_blank"
              rel="noreferrer"
            >
              GitHub
            </a>
          </div>
        </div>

        <div className="toolkit" aria-label="Technical toolkit">
          <span>toolkit</span>
          <div>
            <b>Rust</b>
            <b>TypeScript</b>
            <b>Python</b>
            <b>React</b>
            <b>Linux</b>
            <b>Firebase</b>
            <b>Docker</b>
            <b>GitHub</b>
          </div>
        </div>
      </section>

      <section className="projects-index" id="projects">
        <div className="projects-index-inner">
          <p className="eyebrow eyebrow-light">Selected work</p>
          <h2>PROJECTS</h2>
          <div className="project-list">
            {projects.map((project, index) => (
              <ProjectCard
                key={project.id}
                project={project}
                index={index + 1}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="approach-section">
        <div className="approach-heading">
          <p className="eyebrow">How I work</p>
          <h2>ENGINEERING THAT LEAVES A TRAIL.</h2>
        </div>
        <div className="approach-list">
          <article>
            <span>01</span>
            <h3>Repository as context</h3>
            <p>
              Architecture, current state, active work, and validation evidence
              remain with the project.
            </p>
          </article>
          <article>
            <span>02</span>
            <h3>Explicit boundaries</h3>
            <p>
              Domain truth, presentation, persistence, tooling, and integration
              each get an intentional owner.
            </p>
          </article>
          <article>
            <span>03</span>
            <h3>Evidence over claims</h3>
            <p>
              Implemented, internally tested, and independently verified are
              treated as different states.
            </p>
          </article>
        </div>
      </section>
    </>
  );
}
